import { useRuntimeConfig, useState } from '#imports'

import { useSignifyd } from '@backmarket/nuxt-layer-fraud/useSignifyd'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useIsE2ETestingEnvironment } from '@backmarket/nuxt-module-qa/useIsE2ETestingEnvironment'

/**
 * Initialize Signifyd fraud detection script on component mount.
 * Only loads if enabled via FF_AUTH_SIGNIFYD_ENABLED feature flag.
 */
export function useSignifydOnProfile() {
  const logger = useLogger()
  const config = useRuntimeConfig()
  const isEnabled = config.public.FF_AUTH_SIGNIFYD_ENABLED

  const hasStartedFingerprinting = useState(() => false)

  const isE2ETestingEnvironment = useIsE2ETestingEnvironment()

  if (!isEnabled || isE2ETestingEnvironment || hasStartedFingerprinting.value) {
    return
  }

  const { onLoaded } = useSignifyd()
  const loadStartTime = performance.now()

  onLoaded(() => {
    const loadTime = performance.now() - loadStartTime
    logger.info('Signifyd script loaded', {
      owners: ['bot-squad-identity'],
      loadTimeMs: loadTime,
    })
    hasStartedFingerprinting.value = true
  })
}
